module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-welcome"
  }, [_c('div', {
    staticClass: "home-welcome__header"
  }, [_c('div', {
    staticClass: "home-welcome__header-title"
  }, [_vm._v(_vm._s(_vm.content.welcome.title))]), _c('img', {
    staticClass: "home-welcome__main-logo",
    attrs: {
      "src": _vm.content.welcome.logo,
      "title": "About Logo"
    }
  })]), _c('div', {
    staticClass: "home-welcome__row"
  }, [_c('div', {
    staticClass: "home-welcome__body",
    domProps: {
      "innerHTML": _vm._s(_vm.content.welcome.text)
    }
  })]), _c('div', {
    staticClass: "home-welcome__row"
  }, [_c('div', {
    staticClass: "home-welcome__col"
  }, [_c('div', {
    staticClass: "home-welcome__left-content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.welcome.text_left)
    }
  })]), _c('div', {
    staticClass: "home-welcome__col"
  }, [_c('div', {
    staticClass: "home-welcome__right-content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.welcome.text_right)
    }
  })])]), _c('div', {
    staticClass: "home-welcome__logo-row"
  }, [_c('div', {
    staticClass: "home-welcome__logos-box"
  }, _vm._l((_vm.content.contests.images), function(icon) {
    return _c('img', {
      staticClass: "home-welcome__logos",
      attrs: {
        "src": icon.image,
        "title": "About Logo"
      }
    })
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1c27428","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-home-welcome/custom-home-welcome.pug
// module id = 660
// module chunks = 1